import * as types from './type.js'
export default {
  [types.LOADING_SHOW]: false,
  [types.LOADING_TITLE]: '加载中...',
  sid: 0,
  isPhone: false,
  isFullscreen: false,
  siteurl: '',
  officeWebUrl: ''
}
